import React from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';

import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/dialogStyle';

const useStyles = makeStyles(styles);

const InfoDialog = ({ title, message, children, onConfirm, confirmBtnText }) => {
	const classes = useStyles();

	return (
		<div>
			<SweetAlert
				style={{ display: 'block', marginTop: '-100px' }}
				title={title}
				onConfirm={onConfirm}
				confirmBtnCssClass={`${classes.button} ${classes.danger}`}
				confirmBtnText={confirmBtnText}
			>
				{children || message}
			</SweetAlert>
		</div>
	);
};

export default InfoDialog;

InfoDialog.propTypes = {
	title: PropTypes.string.isRequired,
	message: PropTypes.node,
	onConfirm: PropTypes.func,
	confirmBtnText: PropTypes.string,
};
